import React from 'react'
import './rds.style.css'

function RedStart_Required() {
  return (
    <strong className="rdsreqd-strong">*</strong>
  )
}

export default RedStart_Required